import { useStableCallback } from '@main/shared/browser';
import { errorToast, successToast } from '@main/ui';

import { useUpdatePlatformUsersMutation } from './update-user.admin.generated';

export function useUpdateUserPasswordAccessAction(refetchQuery: () => void) {
  const [updateUser] = useUpdatePlatformUsersMutation();

  return useStableCallback(
    async ({
      userIds,
      isPasswordDisabled,
    }: {
      userIds: string | string[];
      isPasswordDisabled: boolean;
    }) => {
      try {
        await updateUser({
          userIds: userIds,
          users_set_input: {
            password_disabled: isPasswordDisabled,
          },
        }).unwrap();
        refetchQuery();
        successToast(`Password access ${isPasswordDisabled ? 'disabled' : 'enabled'} successfully`);
      } catch {
        errorToast('Failed to toggle password access');
      }
    },
  );
}
